import { useTrackers } from '@ps/web-shared-analytics';
import { Link } from '@ps/web-shared-components';
import classNames from 'clsx';
import { kebabCase } from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';

import InfoIcon from '@swf/core/assets/casino/info.svg';
import { useWidget } from '@swf/core/hooks/useWidget';
import { type Dispatch } from '@swf/core/store';
import type { CasinoGame } from '@swf/core/types/CasinoGame';

import styles from './GameInfoIconSL.scss';

interface Props {
  className?: string;
  game: CasinoGame;
  index?: number;
  count?: number;
}

const GameInfoIconSL: React.FC<Props> = ({ className, count, game, index }) => {
  const { modal } = useDispatch<Dispatch>();
  const { trackInfo } = useTrackers();
  const { widgetId } = useWidget();

  const launchInfoPage = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    trackInfo(game, index, count);
    modal.enqueue({ path: '/casino/game-info', locationState: { game, widgetId } });
  };

  if (!game?.name) return null;

  return (
    <Link
      className={classNames(
        className,
        styles.info,
        styles.cornerButton,
        styles.cornerButtonContainer
      )}
      onClick={launchInfoPage}
      alias="casinoGameInfo"
      title={game.name}
      values={{ name: kebabCase(game.name), gtype: game.gametype, vtype: game.variant }}
    >
      <InfoIcon />
    </Link>
  );
};

export default GameInfoIconSL;
